export const regexPattern = {
  URL_REGEX:
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/i,

  EMAIL: /^\S+@\S+\.\S+$/,
  PhoneNumber: /^\+?[0-9]\d{8,9}$/,
} as const;
